<template>
    <div class="container-fluid default-dashboard">
        <div class="row widget-grid">
            <TableListClouds @update:filterStatus="onStatusFilterChange"/>
            <FormListClouds v-model="listCloud" :listStatus="listStatus"/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent, onMounted } from 'vue'
const TableListClouds = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/TableListClouds.vue"))
const FormListClouds = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/FormListClouds.vue"))

import { directus } from '@/services/directus';
import { readItems } from '@directus/sdk';

const listCloud = ref([])
const listStatus = ref({ cloud_name: [] });

function onStatusFilterChange(statusList) {
    listStatus.value = statusList;
}

async function fetchCloudList() {
    const clouds = await directus.request(
        readItems("clouds", {
            fields: ["*.*"],
            limit: -1,
        })
    );

    const clouds_product = await directus.request(
        readItems("clouds_product", {
            fields: ["cloud_name"],
            limit: -1,
        })
    );

    const grouped = {};
    for (const product of clouds_product) {
        grouped[product.cloud_name] = [];
    }
    for (const cloud of clouds) {
        const key = cloud.clouds_name;
        if (grouped[key]) {
            grouped[key].push(cloud);
        } else {
            if (!grouped['ไม่ระบุประเภท']) grouped['ไม่ระบุประเภท'] = [];
            grouped['ไม่ระบุประเภท'].push(cloud);
        }
    }

    // Remove groups with no data
    const filteredGrouped = {};
    for (const key in grouped) {
        if (grouped[key].length > 0) {
            filteredGrouped[key] = grouped[key];
        }
    }

    listCloud.value = filteredGrouped;
}

onMounted(() => {
    fetchCloudList()
})
</script>